import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export const PREMIUM_FEATURES_COHORT_VARIANT = 'variant';
export const PREMIUM_FEATURES_COHORT_CONTROL = 'control';
export const PREMIUM_FEATURES_COHORT_NOT_ENROLLED = 'not-enrolled';

export function getPremiumFeaturesExperiment() {
	const [config, fire] = UNSAFE_noExposureExp('demonstrating_the_value_of_jira_premium_features');
	const cohort = config.get('cohort', PREMIUM_FEATURES_COHORT_NOT_ENROLLED);

	return {
		cohort,
		fire,
	};
}
